/**
 * Builds a minimal StudentContext value for admin course preview.
 * @param {{
 *   course: { _id?: string; titulo?: string; pestanasCurso?: string[] } | null;
 * }} params
 */
export function buildAdminCoursePreviewStudentValue({ course }) {
  const pestanasCurso = Array.isArray(course?.pestanasCurso)
    ? course.pestanasCurso.filter((p) => typeof p === "string" && p.trim())
    : [];

  return {
    userProfile: null,
    courses: course ? [course] : [],
    activeCourse: course
      ? {
          _id: course._id,
          titulo: course.titulo ?? "",
          pestanasCurso,
        }
      : null,
    setActiveCourse: () => {},
    loading: false,
    error: null,
    refreshCourses: async () => {},
    messagingEnabled: false,
    hasMessagingThreads: false,
    showMessagingNav: false,
    requestMessagingOverride: async () => false,
    activeCourseTabHints: {
      contenidoTabs: pestanasCurso,
      testBlocks: [],
    },
  };
}

/**
 * @param {Record<string, unknown>} rawContenido
 * @param {string[]} pestanasCurso
 * @returns {Record<string, unknown>}
 */
export function buildAdminPreviewCourseShape(rawContenido, pestanasCurso) {
  const tabs =
    pestanasCurso.length > 0
      ? pestanasCurso
      : Object.keys(rawContenido || {}).filter((key) => key.trim());

  const contenido = {};
  for (const tab of tabs) {
    const nodes = rawContenido?.[tab];
    contenido[tab] = Array.isArray(nodes) ? nodes : [];
  }
  return contenido;
}
